import { default as BooleanIcon } from "../../assets/icons/boolean.svg?react";
import { default as TextIcon } from "../../assets/icons/text.svg?react";
import { default as NumberIcon } from "../../assets/icons/number.svg?react";
import { default as ObjectIcon } from "../../assets/icons/object.svg?react";
import { default as DatetimeIcon } from "../../assets/icons/datetime.svg?react";
import { default as GeospatialIcon } from "../../assets/icons/geospatial.svg?react";
import { useMemo } from "react";
import { Stack } from "@altimateai/lego";

interface Props {
  datatype: string;
  color?: string;
  size?: string;
}

const ColumnDatatype = ({ datatype, color = "", size = "1rem" }: Props) => {
  const [Icon, compColor] = useMemo(() => {
    switch (datatype.toLowerCase()) {
      case "integer":
      case "float":
      case "double precision":
      case "double":
      case "bigint":
        return [NumberIcon, "#FF754C"];
      case "bool":
      case "boolean":
        return [BooleanIcon, "#00A5DB"];
      case "text":
      case "character":
      case "character varying":
      case "varchar":
        return [TextIcon, "#3F8CFF"];
      case "geospatial":
        return [GeospatialIcon, "#01CD8C"];
      case "date":
      case "timestamp":
      case "timestamp with time zone":
        return [DatetimeIcon, "#247EFE"];
      default:
        return [ObjectIcon, "#6A24FE"];
    }
  }, [datatype]);

  return (
    <Stack style={{ color: color || compColor }} align="center">
      <Icon width={size} height={size} />
    </Stack>
  );
};

export { ColumnDatatype };
